import { gql } from '@apollo/client'

export const FLAG_CLASSIFICATION_BATCH = gql`
  mutation FlagClassificationBatch($input: FlagClassificationBatchInput!) {
    flagClassificationBatch(input: $input) {
      __typename
      ... on ClassificationFlagBatchResult {
        success
        boundingBoxes {
          id
          isFlagged
          leasedById
        }
      }
    }
  }
`
